<div class="modal-box add-note-modal" cdkDrag>
    <form class="add-note-modal__form modal-form" [formGroup]="addNoteForm" (ngSubmit)="onSubmit()">
        <div class="modal-header add-note-modal__header" cdkDragHandle>
            <div class="add-note-modal__headline modal-headline">
                <span class="add-note-modal__eyebrow modal-eyebrow">{{ 'NOTE' | translate }}</span>
                <h4 class="modal-title add-note-modal__title modal-heading">{{ (f.id.value === null ? 'ADD_NOTE' : 'EDIT_NOTE') | translate }}</h4>
            </div>
            <button type="button" class="add-note-modal__close modal-close" [attr.aria-label]="'CLOSE' | translate" (click)="activeModal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body add-note-modal__body">
            <div class="add-note-modal__sections modal-sections">
                <section class="add-note-modal__panel modal-panel">
                    <div class="add-note-modal__grid modal-grid">
                        <div class="add-note-modal__field add-note-modal__field--span-2 modal-field">
                            <label class="add-note-modal__label modal-label" for="title">{{ 'TITLE' | translate }}</label>
                            <ng-select *ngIf="f.id.value === null && !isExternalUser"
                                id="title"
                                class="add-note-modal__select modal-select no-disabled-dropdown"
                                [placeholder]="'NOTE_TITLE' | translate"
                                [items]="sortedNoteTemplates"
                                bindLabel="title"
                                bindValue="title"
                                notFoundText=""
                                [clearable]="true"
                                (search)="onTitleSearch($event)"
                                (blur)="commitTypedTitle()"
                                formControlName="title"
                                [ngClass]="{ 'is-invalid': submitted && f.title.errors }">
                                <ng-template ng-label-tmp let-item="item">
                                    {{ item?.title }}
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item">
                                    {{ item?.title }}
                                </ng-template>
                            </ng-select>
                            <input *ngIf="f.id.value !== null || isExternalUser" id="title" type="text" class="form-control add-note-modal__control modal-control" formControlName="title"
                                [ngClass]="{ 'is-invalid': submitted && f.title.errors }" [placeholder]="'NOTE_TITLE' | translate">
                            <div *ngIf="submitted && f.title.errors" class="add-note-modal__feedback modal-feedback">
                                <div *ngIf="f.title.errors.required">{{ 'TITLE_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="add-note-modal__field add-note-modal__field--span-2 modal-field">
                            <label class="add-note-modal__label modal-label" for="description">{{ 'NOTE' | translate }}</label>
                            <textarea id="description" rows="5" class="form-control add-note-modal__control add-note-modal__control--textarea modal-control modal-control--textarea" formControlName="description"
                                [ngClass]="{ 'is-invalid': submitted && f.description.errors }"
                                [placeholder]="'NOTE' | translate"></textarea>
                            <div *ngIf="submitted && f.description.errors" class="add-note-modal__feedback modal-feedback">
                                <div *ngIf="f.description.errors.required">{{ 'NOTE_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div *ngIf="!isExternalUser" class="add-note-modal__toggle-row add-note-modal__field--span-2">
                            <div class="add-note-modal__field modal-field">
                                <label class="add-note-modal__toggle-shell add-note-modal__toggle-option" for="isInternal">
                                    <input id="isInternal" type="checkbox" formControlName="isInternal" class="form-check-input" />
                                    <span class="add-note-modal__label add-note-modal__toggle-label modal-label">{{ 'INTERNAL_ONLY' | translate }}</span>
                                </label>
                            </div>

                            <div *ngIf="!instance.isAltLayout" class="add-note-modal__field modal-field">
                                <label class="add-note-modal__toggle-shell add-note-modal__toggle-option" for="pin">
                                    <input id="pin" type="checkbox" formControlName="pin" class="form-check-input" />
                                    <span class="add-note-modal__label add-note-modal__toggle-label modal-label">{{ 'PIN' | translate }}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="add-note-modal__panel modal-panel">
                    <div class="add-note-modal__grid modal-grid">
                        <div class="add-note-modal__field add-note-modal__field--span-2 modal-field">
                            <label class="add-note-modal__label modal-label" for="assignedUserId">{{ 'AUTHOR' | translate }}</label>
                            <div *ngIf="f.assignedUserId.value" class="add-note-modal__readonly">{{ assignedUserFullname }}</div>

                            <select *ngIf="!(f.assignedUserId.value)"
                                id="assignedUserId"
                                [ngClass]="{ 'is-invalid': submitted && f.assignedUserId.errors }"
                                formControlName="assignedUserId"
                                class="form-control form-select add-note-modal__control add-note-modal__select-custom modal-control">
                                <option *ngFor="let rep of allAssignees" [ngValue]="rep.id">{{rep.firstName}} {{rep.lastName}}</option>
                            </select>
                            <div *ngIf="submitted && f.assignedUserId.errors" class="add-note-modal__feedback modal-feedback">
                                <div *ngIf="f.assignedUserId.errors.required">{{ 'PLEASE_SELECT_AN_AUTHOR' | translate }}</div>
                            </div>
                        </div>

                        <div class="add-note-modal__field add-note-modal__field--span-2 modal-field">
                            <label class="add-note-modal__label modal-label">{{ 'ATTACH_FILE' | translate }}</label>
                            <div class="add-note-modal__upload-shell">
                                <ngx-dropzone class="add-note-modal__dropzone" [multiple]="false" (change)="onSelect($event)">
                                    <ngx-dropzone-label>{{ 'DROP_OR_CLICK_TO_UPLOAD' | translate }}</ngx-dropzone-label>
                                </ngx-dropzone>

                                <div class="add-note-modal__file-list" *ngIf="files.length > 0">
                                    <div class="add-note-modal__file-item" *ngFor="let file of files">
                                        <span class="add-note-modal__file-name">{{ file.name }}</span>
                                        <button type="button" class="add-note-modal__file-remove" (click)="onRemove(file)">
                                            <i class="fas fa-trash-can"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <div class="modal-footer add-note-modal__footer" cdkDragHandle>
            <div class="add-note-modal__actions modal-actions">
                <button type="button" class="red-outline-button add-note-modal__button modal-button" (click)="activeModal.close('Close click')">{{ 'CANCEL' | translate }}</button>
                <button type="submit" class="blue-button add-note-modal__button modal-button">{{ 'SAVE' | translate }}</button>
            </div>
        </div>
    </form>
</div>
